import { render, staticRenderFns } from "./allWater.vue?vue&type=template&id=5ce55c3c&scoped=true"
import script from "./allWater.vue?vue&type=script&lang=js"
export * from "./allWater.vue?vue&type=script&lang=js"
import style0 from "./allWater.vue?vue&type=style&index=0&id=5ce55c3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce55c3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce55c3c')) {
      api.createRecord('5ce55c3c', component.options)
    } else {
      api.reload('5ce55c3c', component.options)
    }
    module.hot.accept("./allWater.vue?vue&type=template&id=5ce55c3c&scoped=true", function () {
      api.rerender('5ce55c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/institutionalWalletChild/allWater.vue"
export default component.exports